<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Aplicativo móvel
            </h2>
        </template>
            <flash :timeout="5000"/>
    <!-- :href="route('peopleupdate.edit')"-->
        <div class="pt-16 pb-6">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div>
                    <mobile-application-authorization :mobile_device="mobile_device" :qrcode="qrcode" :user = "user" />
                    <jet-section-border />
                </div>
            </div>
        </div>
        <div class="pb-6">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div>
                    <mobile-application-authentication :user = "user" :current_password="current_password" />
                    <jet-section-border />
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from './../../Layouts/AppLayout'
    import JetSectionBorder from './../../Jetstream/SectionBorder'
    import MobileApplicationAuthorization from './MobileApplicationAuthorization';
    import MobileApplicationAuthentication from './MobileApplicationAuthentication';
    import Flash from '../../Helpers/Flash.vue';

    export default {
        props: ['user','current_password','mobile_device','qrcode'],

        components: {
            AppLayout,
            JetSectionBorder,
            MobileApplicationAuthorization,
            MobileApplicationAuthentication,
            Flash
        },
    }
</script>
